/**
 * AddRowsCtrl controller
 */
// preload drag'n'drop image
const dragndropImg = new window.Image()
dragndropImg.src = require('./img/dragndrop.png')

// controller mixins
AddRowsCtrl.mixes = [
  'openPopupCtrlMixin'
]

/**
 * AddRowsCtrl controller
 *
 * @class AddRowsCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 * @mixes mwApp/common.mixin:openPopupCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:AddRowsCtrl
 */
/* @ngInject */
export default function AddRowsCtrl (
  $location,
  $scope,
  $uibModal,
  $uibModalInstance,
  NetworkRow,
  assignedRows,
  availableRows,
  moduleType
) {
  var vm = this
  vm.rows = { assigned: { rows: angular.copy(assignedRows) }, available: { rows: angular.copy(availableRows) } }
  vm.labels = [
    'ALL',
    'DEFAULT',
    'LIVE',
    'SERIES',
    'MOVIES',
    'EVENTS',
    'EXTERNAL',
    'SHELF',
    'OTHER'
  ]
  vm.availableFilter = ''
  vm.assignedFilter = ''
  vm.isFormDisabled = true
  vm.availableFilterLabel = 'ALL'
  vm.assignedFilterLabel = 'ALL'
  vm.moduleType = moduleType

  /**
   * In the dnd-drop callback, we now have to handle the data array that we
   * sent above. We handle the insertion into the list ourselves. By returning
   * true, the dnd-list directive won't do the insertion itself.
   */
  vm.onDrop = function (list, items, index) {
    // eslint-disable-next-line no-undef
    event.stopPropagation()
    list.rows = list.rows
      .slice(0, index)
      .concat(items)
      .concat(list.rows.slice(index))
    items.forEach(item => { item.selected = !item.selected })
    vm.isFormDisabled = false
    return true
  }

  /**
   * dnd-dragging determines what data gets serialized and send to the receiver
   * of the drop. While we usually just send a single object, we send the array
   * of all selected items here.
   */
  vm.getSelected = function (list, link) {
    // eslint-disable-next-line no-undef
    event.stopPropagation()
    link.selected = true
    return list.filter(link => link.selected)
  }
  /**
   * Delete row from assigned
   *
   * @memberof mwApp/packages.controller:AddRowsCtrl
   */
  vm.deleteRow = function (row) {
    event.preventDefault()
    row.selected = false
    vm.rows.assigned.rows = vm.rows.assigned.rows.filter(r => r.$uuid !== row.$uuid)
    vm.rows.available.rows.push(row)
    vm.rows.assigned.rows.forEach((row, i) => {
      row.sortOrder = i + 1
    })
    vm.isFormDisabled = false
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragstart = function (list, event) {
    list.dragging = true
    if (event.dataTransfer.setDragImage) {
      event.dataTransfer.setDragImage(dragndropImg, 0, 0)
    }
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragend = function (list) {
    list.dragging = false
    vm.rows.assigned.rows.forEach((row, i) => {
      row.sortOrder = i + 1
      row.selected = false
    })
  }

  /**
   * Last but not least, we have to remove the previously dragged items in the
   * dnd-moved callback.
   */
  vm.onMoved = function (list) {
    list.rows = list.rows.filter(item => !item.selected)
  }

  /**
   * Create or edit season, and close modal window afterwards
   *
   * @memberof mwApp/addContentSets.controller:AddRowsCtrl
   */
  vm.submit = function () {
    $uibModalInstance.close({
      assigned: vm.rows.assigned.rows,
      available: vm.rows.available.rows
    })
  }

  /**
   * Method for filtering assigned rows
   *
   * @param {Object} row
   * @memberof mwApp/packages.controller:AddRowsCtrl
   */
  vm.filteredAssigned = (row) => {
    const filterByTitle = vm.assignedFilter.length > 0
      ? row.title.toLowerCase().includes(vm.assignedFilter.toLowerCase())
      : true
    const filterByLabel = vm.assignedFilterLabel !== 'ALL'
      ? row.labels.includes(vm.assignedFilterLabel)
      : true
    return filterByTitle && filterByLabel
  }

  /**
   * Method for filtering available Rows
   *
   * @param {Object} row
   * @memberof mwApp/packages.controller:AddRowsCtrl
   */
  vm.filteredAvailable = (row) => {
    const filterByTitle = vm.availableFilter.length > 0
      ? row.title.toLowerCase().includes(vm.availableFilter.toLowerCase())
      : true
    const filterByLabel = vm.availableFilterLabel !== 'ALL'
      ? row.labels.includes(vm.availableFilterLabel)
      : true
    return filterByTitle && filterByLabel
  }

  /**
   * Cancel editing, close modal window
   *
   * @memberof mwApp/addContentSets.controller:AddRowsCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
